import React from 'react'
import { Segment, Header, Icon, Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const NotFound = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
        Oops - No pudimos encontrar la p&aacute;gina solicitada.
      </Header>
            <Segment.Inline>
                <Button as={Link} to='/' primary>
                    Retornar p&aacute;gina principal.
        </Button>
            </Segment.Inline>
        </Segment>
    )
}

export default NotFound
